/* eslint-disable no-prototype-builtins */
// Extends From
import Service from '@ember/service';
// Ember Imports
import { service } from '@ember/service';
// External Imports
import config from '@linc-technologies/linced-common/utils/config';

/**
 * hero-api-people provides a service to manually interact with and maybe
 * return normalised responses from the Hero People API.
 */
export default class HeroApiPeopleService extends Service {
  // Services
  @service
  fetch;

  @service
  store;

  // Properties
  // baseURI provides the base URI for talking to the people service.
  baseURI = `${config.APP.apiHost}/people/v4`;

  // Methods
  /**
   * updatePersonOptions enables updating a person's options.
   *
   * @param {String} schoolId - The schoolId
   * @param {String} personId
   * @param {Object} options
   * @return {*}
   */
  updatePersonOptions(schoolId, personId, options, updateOptionProps) {
    const uri = `${this.baseURI}/people/${personId}/:options`;
    const data = {
      schoolId,
      personId,
      options,
      updateOptionProps,
    };
    const payload = {
      data: JSON.stringify(data),
    };

    return this.fetch.post(uri, payload).then((response) => {
      if (!response || !response.options) {
        // Don't attempt to inject bad data...
        return;
      }

      // Default booleans to false, since the backend will `omitempty` them.
      ['autosaveNumericGrades', 'progressOverviewControlsMinimised'].forEach(
        (boolProp) => {
          if (!response.options.hasOwnProperty(boolProp)) {
            response.options[boolProp] = false;
          }
        },
      );

      // push in a partial update in the way ember expects to have received
      // a payload for a person, so it can filter down and react to changes
      // in the model.
      this.store.pushPayload('person', {
        person: {
          id: personId,
          options: response.options,
        },
      });
    });
  }
}
